import { z } from 'zod'

import { generateRandomString } from '@mntn-dev/utilities'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const MntnCreditProgramIdSchema = z
  .string()
  .min(1)
  .max(128)
  .brand<'mntn-credit-program-id'>()

export type MntnCreditProgramId = ZodInfer<typeof MntnCreditProgramIdSchema>

export const MntnCreditProgramId = (value: string = generateRandomString()) => {
  return MntnCreditProgramIdSchema.parse(value)
}
